<template>
<div>
    <el-container style="height: 1500px; border: 1px solid #eee; margin:0 100px 0 100px">
        <el-aside width="200px" style="background-color: rgb(238, 241, 246); height: 200px">
            <h1 class="title">资质证书</h1>
            <hr class="fenge" size="5px" noshade=true/>
            <el-menu default-active="2" class="el-menu-vertical-demo">
                <el-menu-item index="1">
                    <i class="el-icon-picture"></i>
                    <span slot="title">3C认证</span>
                </el-menu-item>
            </el-menu>
        </el-aside>
    <el-container> 
    <el-main>  
        <div class="demo-image__preview">
          <el-image style="width: 45%; height: 100%; margin-left: 30px" 
          v-for="url in urls" :key="url" :src="url" lazy>
          </el-image>
        </div>
    </el-main>
  </el-container>
</el-container>
</div> 

</template>

<script>
  export default {
    data() {
      return {
        urls: [
          require("../assets/zhengshu/xinyong.jpg"),
          require("../assets/zhengshu/CCC-HTF-12-1.jpg"),
          require("../assets/zhengshu/CCC-HTF-12-2.jpg"),
          require("../assets/zhengshu/CCC-HTFC-30.jpg"),
          require("../assets/zhengshu/CCC-PYHL-14A-7.5.jpg"),
          require("../assets/zhengshu/1.jpg"),
          require("../assets/zhengshu/2.jpg"),
          require("../assets/zhengshu/3.jpg"),
          require("../assets/zhengshu/4.jpg"),
          require("../assets/zhengshu/5.jpg"),
          require("../assets/zhengshu/6.jpg"),
          require("../assets/zhengshu/7.jpg"),
          require("../assets/zhengshu/8.jpg"),
          require("../assets/zhengshu/9.jpg"),
          require("../assets/zhengshu/10.jpg"),
          require("../assets/zhengshu/11.jpg"),
          require("../assets/zhengshu/12.jpg"),
          require("../assets/zhengshu/13.jpg"),
          require("../assets/zhengshu/14.jpg"),
          require("../assets/zhengshu/15.jpg"),
          require("../assets/zhengshu/16.jpg"),
          require("../assets/zhengshu/17.jpg"),
          require("../assets/zhengshu/18.jpg"),
          require("../assets/zhengshu/19.jpg"),
          require("../assets/zhengshu/20.jpg"),
          require("../assets/zhengshu/21.jpg"),
          require("../assets/zhengshu/22.jpg"),
          require("../assets/zhengshu/23.jpg"),
          require("../assets/zhengshu/24.jpg"),
          require("../assets/zhengshu/25.jpg"),
          require("../assets/zhengshu/26.jpg"),
          require("../assets/zhengshu/27.jpg"),
          require("../assets/zhengshu/28.jpg"),
          require("../assets/zhengshu/29.jpg"),
          require("../assets/zhengshu/30.jpg"),
          require("../assets/zhengshu/31.jpg"),
          require("../assets/zhengshu/32.jpg"),
          require("../assets/zhengshu/33.jpg"),
          require("../assets/zhengshu/34.jpg"),
          require("../assets/zhengshu/35.jpg"),
          require("../assets/zhengshu/36.jpg"),
          require("../assets/zhengshu/37.jpg"),
        ]
      }
    }
  }
</script>

<style scoped>

.fenge {
    width: 95px;
    margin-top: 0;
    margin-left: 15px;
    background-color: rgb(24, 140, 179);
    border: rgb(24, 140, 179);
    box-shadow: 0 0 0 0;
}

.title {
    font-size: 200%;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-left: 15px;
}
</style>
